module.exports = __webpack_public_path__ + "assets/a234acc62cbdf30d49e862acd21ad9e9.mp3";